module.exports = __webpack_public_path__ + "image/VP_logo1.png";